import { Flex } from '@chakra-ui/layout';
import { chakra } from '@chakra-ui/system';

export const container = chakra(Flex, {
    label: 'user-profile-button-container',
    baseStyle: {
        fontFamily: 'Poppins, sans-serif',
        justifyContent: 'space-between',
        fontWeight: 400,
        fontSize: '16px',
        letterSpacing: '-0.15px',
        color: 'neutral.700',
        borderTop: '1px solid #DBE0E6',
        w: '100vw',
        h: '48px',
        p: '12px',
        alignItems: 'center',
        _hover: { backgroundColor: '#F2F5F7' }
    }
});
